import live from '@/assets/imgs/Home/icon-live.png';
import upcoming from '@/assets/imgs/Home/icon-clock.png';
import replay from '@/assets/imgs/Home/icon-replay.png';

const Tabs = {
  Live: {
    type: 'Live',
    icon: live,
  },
  Upcoming: {
    type: 'Upcoming',
    icon: upcoming,
  },
  Replay: {
    type: 'Replay',
    icon: replay,
  }
}
export {
  Tabs
};